import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import * as Styled from "./styles";

interface DriverReadViewProps {
  driverName?: string;
  driverSurname?: string;
  showDriverIdentity: boolean;
  canSelectDriver: boolean;
  canChangeDriver: boolean;
  onSelect: () => void;
}

function trimPart(value?: string): string {
  return (value ?? "").trim();
}

function buildDisplayAndInitial(
  firstName?: string,
  surname?: string,
): { display: string; initial: string } {
  const f = trimPart(firstName);
  const s = trimPart(surname);
  const display = [f, s].filter(Boolean).join(" ");
  const sourceForInitial = f || s;
  const initial = sourceForInitial
    ? sourceForInitial.charAt(0).toLocaleUpperCase("pt-BR")
    : "";
  return { display, initial };
}

function DriverReadView({
  driverName,
  driverSurname,
  showDriverIdentity,
  canSelectDriver,
  canChangeDriver,
  onSelect,
}: DriverReadViewProps): JSX.Element {
  const { t } = useTranslation();

  const { display, initial } = useMemo(
    () => buildDisplayAndInitial(driverName, driverSurname),
    [driverName, driverSurname],
  );

  const canShowAction =
    (showDriverIdentity && canChangeDriver) ||
    (!showDriverIdentity && canSelectDriver);
  const buttonLabel = showDriverIdentity
    ? t("changeDriver")
    : t("selectDeliveryPerson");

  return (
    <Styled.ContainerDriver
      $withReadPadding={showDriverIdentity && canShowAction}
    >
      <Styled.ContainerDrive>
        {showDriverIdentity && (
          <Styled.ContainerDriverSelected>
            <Styled.DriverAvatarCircle aria-hidden>
              {initial}
            </Styled.DriverAvatarCircle>
            <Styled.DriverDisplayName title={display}>
              {display}
            </Styled.DriverDisplayName>
          </Styled.ContainerDriverSelected>
        )}
        {canShowAction && (
          <Styled.Button type="button" onClick={onSelect}>
            <Styled.ButtonAccept>
              {buttonLabel.toUpperCase()}
            </Styled.ButtonAccept>
          </Styled.Button>
        )}
      </Styled.ContainerDrive>
    </Styled.ContainerDriver>
  );
}

export default DriverReadView;
